import React from 'react';
import { Box, Typography } from '@mui/material';
import { INVOICE_THEME } from '../utils/invoiceDesignTokens';

export default function InvoiceEditorSection({ icon, title, subtitle, action, children, defaultOpen = true }) {
  const [open, setOpen] = React.useState(defaultOpen);

  return (
    <Box
      sx={{
        borderRadius: `${INVOICE_THEME.radius}px`,
        border: `1px solid ${INVOICE_THEME.border}`,
        bgcolor: INVOICE_THEME.surface,
        overflow: 'hidden',
        transition: 'box-shadow 0.25s ease',
        '&:hover': { boxShadow: INVOICE_THEME.shadowSoft },
      }}
    >
      <Box
        role="button"
        tabIndex={0}
        onClick={() => setOpen((v) => !v)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setOpen((v) => !v);
          }
        }}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          px: 2,
          py: 1.75,
          cursor: 'pointer',
          background: INVOICE_THEME.gradientSoft,
          borderBottom: open ? `1px solid ${INVOICE_THEME.border}` : 'none',
          userSelect: 'none',
        }}
      >
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: '12px',
            display: 'grid',
            placeItems: 'center',
            background: INVOICE_THEME.gradient,
            color: '#fff',
            flexShrink: 0,
            boxShadow: '0 6px 16px rgba(59, 130, 246, 0.28)',
          }}
        >
          {icon}
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography sx={{ fontWeight: 700, color: INVOICE_THEME.ink, fontSize: '0.95rem' }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography sx={{ fontSize: '0.78rem', color: INVOICE_THEME.slate, mt: 0.25 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
        {action}
        <Typography
          sx={{
            fontSize: '1.1rem',
            color: INVOICE_THEME.slate,
            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s ease',
            lineHeight: 1,
          }}
        >
          ▾
        </Typography>
      </Box>
      {open && <Box sx={{ p: 2, display: 'grid', gap: 2 }}>{children}</Box>}
    </Box>
  );
}
